module.exports = __webpack_public_path__ + "static/iphone2-03f8adf2d33e76cde7d2f3352806c30d.png";